import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEY = "mjm_session_token";
export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t && !cfg.headers.Authorization) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
export const saveToken = (data) => { if (data?.session_token) localStorage.setItem(TOKEN_KEY, data.session_token); };
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const errMsg = (e) => e?.response?.data?.detail || e?.message || "Terjadi kesalahan";

export const waPhone = (p) => { let d = String(p || "").replace(/\D/g, ""); if (d.startsWith("0")) d = "62" + d.slice(1); if (d.startsWith("8")) d = "62" + d; return d; };
export const waLink = (phone, message) => `https://wa.me/${waPhone(phone)}?text=${encodeURIComponent(message || "")}`;
export const openWa = (phone, message) => window.open(waLink(phone, message), "_blank", "noopener");

export const rp = (n) =>
  n === null || n === undefined ? "-" : "Rp" + Math.round(Number(n)).toLocaleString("id-ID");

export const dt = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  return d.toLocaleString("id-ID", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
};

export const dateOnly = (iso) => (iso ? new Date(iso).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" }) : "-");

export const STATUS_COLORS = {
  WAITING: "bg-zinc-700 text-zinc-100",
  DIAGNOSIS: "bg-sky-900/70 text-sky-200",
  WAITING_PART: "bg-amber-900/70 text-amber-200",
  IN_PROGRESS: "bg-blue-900/70 text-blue-200",
  WAITING_APPROVAL: "bg-orange-900/70 text-orange-200",
  WAITING_QC: "bg-violet-900/70 text-violet-200",
  READY: "bg-emerald-900/70 text-emerald-200",
  PAID: "bg-emerald-700 text-white",
  COMPLETED: "bg-zinc-800 text-zinc-300",
  CANCELLED: "bg-red-950 text-red-300",
  WAITING_WAREHOUSE: "bg-amber-900/70 text-amber-200",
  SCANNED: "bg-blue-900/70 text-blue-200",
  ISSUED: "bg-emerald-900/70 text-emerald-200",
  REJECTED: "bg-red-950 text-red-300",
  PENDING: "bg-orange-900/70 text-orange-200",
  APPROVED: "bg-emerald-900/70 text-emerald-200",
  DRAFT: "bg-zinc-700 text-zinc-100",
  ORDERED: "bg-blue-900/70 text-blue-200",
  PARTIAL: "bg-amber-900/70 text-amber-200",
  RECEIVED: "bg-emerald-900/70 text-emerald-200",
  CLOSED: "bg-zinc-800 text-zinc-300",
  REVIEW: "bg-sky-900/70 text-sky-200",
  SENT: "bg-emerald-900/70 text-emerald-200",
  LOGGED: "bg-zinc-700 text-zinc-100",
  FAILED: "bg-red-950 text-red-300",
  NEW: "bg-blue-900/70 text-blue-200",
  READY_TO_SHIP: "bg-amber-900/70 text-amber-200",
  SHIPPED: "bg-emerald-900/70 text-emerald-200",
  AMAN: "bg-emerald-900/70 text-emerald-200",
  RENDAH: "bg-amber-900/70 text-amber-200",
  KRITIS: "bg-orange-900/70 text-orange-200",
  HABIS: "bg-red-950 text-red-300",
  VOID: "bg-red-950 text-red-300 ml-2",
  REQUESTED: "bg-amber-900/70 text-amber-200",
  CONFIRMED: "bg-emerald-900/70 text-emerald-200",
  ARRIVED: "bg-blue-900/70 text-blue-200",
  NO_SHOW: "bg-zinc-800 text-zinc-400",
};

export const STATUS_LABEL = {
  WAITING: "Menunggu", DIAGNOSIS: "Diagnosa", WAITING_PART: "Tunggu Part", IN_PROGRESS: "Dikerjakan", WAITING_APPROVAL: "Tunggu Approval",
  WAITING_QC: "QC", READY: "Siap Diambil", PAID: "Lunas", COMPLETED: "Selesai", CANCELLED: "Batal",
  REQUESTED: "Diminta", CONFIRMED: "Dikonfirmasi", ARRIVED: "Datang", NO_SHOW: "Tidak Datang", VOID: "VOID",
  WAITING_WAREHOUSE: "Menunggu Gudang", SCANNED: "Ter-scan", ISSUED: "Dikeluarkan", REJECTED: "Ditolak", PENDING: "Menunggu", APPROVED: "Disetujui",
};
